import {
  Checkbox,
  FormControlLabel,
  MenuItem,
  MenuList,
  Paper,
} from "@mui/material";
import { FC, HTMLAttributes } from "react";
import { useTranslation } from "react-i18next";

interface ISelectAllPaperWrapperProps extends HTMLAttributes<HTMLElement> {
  handleToggleSelectAll: () => void;
  selectAll: boolean;
}

export const SelectAllPaperWrapper: FC<ISelectAllPaperWrapperProps> = ({
  children,
  handleToggleSelectAll,
  selectAll,
  ...restPaperProps
}) => {
  const { t } = useTranslation();

  return (
    <Paper {...restPaperProps}>
      <MenuList dense disablePadding>
        <MenuItem
          onMouseDown={e => {
            e.preventDefault();
            handleToggleSelectAll();
          }}
        >
          <FormControlLabel
            label={t("general.SELECT_ALL")}
            control={
              <Checkbox sx={{ marginInlineEnd: 0.75 }} checked={selectAll} />
            }
          />
        </MenuItem>
      </MenuList>
      {children}
    </Paper>
  );
};
